import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// IMAGES
import imagePerson1 from '../../../images/person1.png'
import imagePerson2 from '../../../images/person2.png'
import imagePerson3 from '../../../images/person3.png'
import imagePerson4 from '../../../images/person4.png'
import imagePerson5 from '../../../images/person5.png'
import ButtonShadow from '../../elements/ButtonShadow'
import ButtonModalOpen from './../../elements/ButtonModalOpen';

// 7ddbd3ff cf92e1ff f6e2e5ff f3bd6aff f1705fff 

const ViewStaff = ({ staff, setValuesStaff }) => { 
    const [showList,setShowList] = useState(false)

    const _colorPerson = (color) => {
        if (color === '7ddbd3ff') {
            return <img src={imagePerson1} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'cf92e1ff') {
            return <img src={imagePerson2} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'f6e2e5ff') {
            return <img src={imagePerson3} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === 'f3bd6aff') {
            return <img src={imagePerson4} alt='image du logo' style={{ height:25, width:25 }} />
        }
        if (color === '7ddbd3ff') {
            return <img src={imagePerson5} alt='image du logo' style={{ height:25, width:25 }} />
        }
    }

    return (
        <div>
            {/* BUTTON ADD STAFF */}
            <ButtonModalOpen
                title='Ajouter un équipier'
                modal='modalStaff'
            />
            
            {staff.filter(l => l.doc === 'docStaff').sort((a,b) => a.nameStaff > b.nameStaff ? 1 : -1).map(l => (
                <div className="shadow row mt-3" key={l.id}>
                    <div className="card-body">
                        <div className='row' onClick={() => setShowList(showList === l.id ? '' : l.id)}> 
                            <div className='col-1 text-center'>
                                {_colorPerson(l.circleColor)}
                            </div>
                            <div className='col-10'> 
                            {l.surnameStaff}  {l.nameStaff}
                            </div>
                            <div className='col-1 text-end'>
                                <i className={showList === l.id ? "bi bi-chevron-compact-up" : "bi bi-chevron-compact-down"}></i>
                            </div>
                        </div>
                        {showList === l.id &&
                        <> 

                            {/* COMPETENCES */}
                            <div className='row border-top mt-3' />
                            <div 
                                className='mt-3 text-center'
                                data-bs-toggle="modal" 
                                data-bs-target="#modalStaffServices" 
                                style={{ cursor:'pointer' }}
                                onClick={() => setValuesStaff({idStaff:l.id, surnameStaff:l.surnameStaff, nameStaff:l.nameStaff})} 
                            >compétences</div>
                            
                            {/* PLAGE HORAIRES */}
                            <div className='row border-top mt-3' />
                            <div className='text-center mt-3'>
                                <Link 
                                    to='/horairesStaff'  
                                    state={{
                                        idStaff:l.id, 
                                        nameStaff:l.nameStaff, 
                                        surnameStaff:l.surnameStaff
                                    }} 
                                    className='text-decoration-none text-dark'
                                >plages horaires</Link>
                            </div>

                            {/* ABSENCES */}
                            <div className='row border-top mt-3' />
                            <div className='text-center mt-3'>
                                <Link 
                                    to='/absencesStaff'  
                                    state={{
                                        idStaff:l.id, 
                                        nameStaff:l.nameStaff, 
                                        surnameStaff:l.surnameStaff 
                                    }} 
                                    className='text-decoration-none text-dark'
                                >absences</Link> 
                            </div>

                            {/* MODIFIER PROFIL */}
                            <div className='row border-top mt-3' />
                            <div className='text-center mt-3'>
                                <Link 
                                    to='/profilStaff'  
                                    state={{
                                        idStaff:l.id, 
                                        nameStaff:l.nameStaff, 
                                        surnameStaff:l.surnameStaff
                                    }} 
                                    className='text-decoration-none text-dark'
                                >modifier profil</Link>
                            </div>

                            {/* SUPPRIMER EQUIPIER */}
                            <div className='row border-top mt-3' />
                            <div 
                                className='text-center mt-3'
                                data-bs-toggle="modal" 
                                data-bs-target="#modalConfirm" 
                                style={{ cursor:'pointer' }}
                                onClick={() => setValuesStaff({idStaff:l.id})} 
                            >Supprimer équipier</div>
                        </>
                        }
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ViewStaff
